<template>
  <div
    v-if="active"
    :style="{borderTopColor: themeColorHEX}"
    ref="wrapper"
    class="border-r-transparent animate-spin after:absolute after:left-0 after:top-0 after:w-12 after:h-12 after:rounded-full after:border-b-4 after:border-b-white after:border-l-4 after:border-l-transparent inline-block w-12 h-12 border-t-4 border-r-4 rounded-full"
  ></div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 't-loader-circle',
    data() {
      return {
        active: true
      }
    },
    computed: {
      ...mapGetters(['themeColorHEX'])
    },
    methods: {
      toggleActive() {
        this.active = !this.active
      }
    }
  }
</script>
